import { render, staticRenderFns } from "./OrderNumberStep.vue?vue&type=template&id=a37efeac"
import script from "./OrderNumberStep.vue?vue&type=script&lang=js"
export * from "./OrderNumberStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Input: require('/vercel/path0/components/common/Input.vue').default})
